<template>
  <div>
    <div>
      祝賀詞與名稱：{{ engravingContent.commemorativeMedalGreetingsAndName }}
    </div>
    <div>祝賀詞：{{ engravingContent.commemorativeMedalGreetingMessage }}</div>
    <div>祝賀圖片：{{ commemorativeMedalGreetingImageDisplayLabel }}</div>
    <div
      v-if="engravingContent.commemorativeMedalGreetingImageOption === 'custom'"
    >
      圖片敘述：{{ engravingContent.commemorativeMedalGreetingImageCustom }}
    </div>
    <div>贈送人姓名：{{ engravingContent.commemorativeMedalSenderName }}</div>
  </div>
</template>
<script>
import { commemorativeMedalGreetingImageOptions } from "@/constData/engravingData";
export default {
  name: "DisplayCommemorativeMedal",
  props: {
    engravingContent: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      commemorativeMedalGreetingImageOptions:
        commemorativeMedalGreetingImageOptions,
    };
  },
  computed: {
    commemorativeMedalGreetingImageDisplayLabel() {
      const option = commemorativeMedalGreetingImageOptions.find(
        (option) =>
          option.value ===
          this.engravingContent.commemorativeMedalGreetingImageOption
      );
      return option ? option.label : "";
    },
  },
};
</script>
<style scoped lang="scss">
div {
  margin: 6px 0;
}
</style>
